import { ComponentType } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withSizes } from 'react-sizes';

import { fetchNewsPage } from 'client/ducks/news/actions';
import { getNewsPage, isLoading } from 'client/ducks/news/selectors';
import { State } from 'client/store';
import paginationWrapper from '@components/pagination-wrapper';
import { mapSizesToProps } from 'client/helpers/sizes';
import { AsyncFetchDataProps } from '@interfaces/async-fetch-data';

import NewsList, { DispatchProps, StateProps } from './news-list';

function mapStateToProps(state: State): StateProps {
    return {
        ...getNewsPage(state),
        isLoading: isLoading(state)
    };
}

const mapDispatchToProps = {
    fetchPage: fetchNewsPage
};

const component = compose<ComponentType>(
    connect<StateProps, DispatchProps>(mapStateToProps, mapDispatchToProps),
    paginationWrapper,
    withSizes(mapSizesToProps)
)(NewsList) as any;

component.asyncFetchData = ({ dispatch }: AsyncFetchDataProps) => dispatch(fetchNewsPage());

export default component;
